<div class="signup-container">
	<div class="logo">
		<img src="assets/logos/serveox-logo-blue.svg" class="img-fluid" alt="ServeOx Logo" />
	</div>

	<h2 class="text-center">Sign Up</h2>

	<app-google-signin></app-google-signin>

	<hr />

	<app-step-navigator [stepConfig]="navigationConfig" [(selectedStep)]="selectedStep"></app-step-navigator>

	<ng-container [ngSwitch]="selectedStep.switchCase">
		<ng-container *ngSwitchCase="AuthMethods.EMAIL">
			<form [formGroup]="emailSignUpForm" class="form-container">
				<app-standard-control
					type="text"
					name="fullName"
					[formGroup]="emailSignUpForm"
					label="Full Name"
					placeholder="Full Name"
					autocomplete="name"
				></app-standard-control>

				<app-standard-control
					type="email"
					name="email"
					[formGroup]="emailSignUpForm"
					label="Email Address"
					placeholder="Email Address"
					autocomplete="email"
				></app-standard-control>

				<app-password-control
					[formGroup]="emailSignUpForm"
					name="password"
					label="Password"
					placeholder="Password"
					autocomplete="new-password"
				></app-password-control>

				<app-password-control
					[formGroup]="emailSignUpForm"
					name="confirmPassword"
					label="Confirm Password"
					placeholder="Confirm Password"
					autocomplete="new-password"
				></app-password-control>

				<button
					type="submit"
					class="btn btn-primary"
					[disabled]="emailSignUpForm.invalid || emailSignUpIsLoading"
					(click)="handleEmailSignUp()"
				>
					<ng-container *ngIf="emailSignUpIsLoading; else notLoading">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</ng-container>
					<ng-template #notLoading> Sign Up </ng-template>
				</button>
			</form>
		</ng-container>

		<ng-container *ngSwitchCase="AuthMethods.PHONE_NUMBER">
			<form [formGroup]="phoneSignUpForm" class="form-container">
				<app-standard-control
					type="text"
					name="fullName"
					[formGroup]="phoneSignUpForm"
					label="Full Name"
					placeholder="Full Name"
					autocomplete="name"
				></app-standard-control>

				<app-phone-number-control [formGroup]="phoneSignUpForm" name="phoneNumber"></app-phone-number-control>

				<ng-container *ngIf="verificationId">
					<app-alert
						[dismissible]="true"
						content="A verification code has been sent to your phone number. Please enter the code below to verify your number."
					></app-alert>
					<app-standard-control
						type="text"
						[formGroup]="phoneSignUpForm"
						name="verificationCode"
						label="Verification Code"
						placeholder="Enter the verification code"
						labelPlacement="floating"
					></app-standard-control>
				</ng-container>

				<div class="button-container">
					<button type="button" class="btn btn-sm btn-outline-danger btn-width" (click)="handleResetPhoneForm()">Reset</button>

					<ng-container *ngIf="!verificationId">
						<button
							id="verificationCodeButton"
							type="button"
							[disabled]="
								verificationCodeLoading ||
								phoneNumber.invalid ||
								phoneNumber.pristine ||
								phoneSignUpForm.controls.fullName.invalid
							"
							class="btn btn-sm btn-primary btn-width"
							(click)="getVerificationCode()"
						>
							<ng-container *ngIf="verificationCodeLoading; else notLoading">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notLoading> Sign Up</ng-template>
						</button>
					</ng-container>

					<ng-container *ngIf="verificationId">
						<button
							type="button"
							[disabled]="phoneSignUpIsLoading || !verificationId || verificationCode.invalid || verificationCode.pristine"
							class="btn btn-sm btn-primary btn-width"
							(click)="handlePhoneNumberSignUp()"
						>
							<ng-container *ngIf="phoneSignUpIsLoading; else notSaving">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notSaving> Verify </ng-template>
						</button>
					</ng-container>
				</div>
			</form>
		</ng-container>
	</ng-container>

	<p class="text-center">
		Already have an account? <a class="text-decoration-none" [routerLink]="'../' + AuthRoutes.LOGIN">Login here.</a>
	</p>
</div>
